module.exports = __webpack_public_path__ + "static/media/OCP-JavaSE8-Programmer-clr.771eba5c.gif";